module.exports = __webpack_public_path__ + "img/cr.bb7217ed.svg";